import * as React from 'react';
import { resolve } from 'inversify-react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { QuotePolicyListDataService } from './quote-policy-list.data';
import { QuotePolicyListView } from './quote-policy-list.view';

@observer
export class QuotePolicyListController extends React.Component<ControllerProps<any>, {}> {
	@observable
	dataService: QuotePolicyListDataService;

	@resolve
	toast: ToastNotifications;

	constructor(props: Readonly<ControllerProps<any>>) {
		super(props);
	}

	componentDidMount() {
		this.props.setBusy(true);
		this.loadData()
			.then(() => {
				this.props.setBusy(false);
			})
			.catch((error) => {
				this.props.setBusy(false);
				this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
			});
	}

	private async loadData(): Promise<void> {
		this.dataService = QuotePolicyListDataService.make();

		this.dataService.pageSize = 20;
		this.dataService.addSorting('id', 'asc', true);
		this.dataService.addFilter('type', 'eq', 0);
		this.dataService.addFilter('isDeleted', 'eq', false);

		await this.dataService.load((query) => query);
	}


	handleItemDoubleClick = (item?: QuotePolicySummary): void => {
		this.props.history.push(`/bookings/quote-policies/${item == null ? 'new' : item.id}`);
	}

	render() {
		if (this.dataService == null || this.dataService.items == null) {
			return null;
		}

		return (
			<QuotePolicyListView
				model={this.dataService}
				setBusy={this.props.setBusy}
				onItemDoubleClicked={this.handleItemDoubleClick}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/quote-policies/list/quote-policy-list.controller.tsx